<template>
  <v-overlay @click="close" z-index="300" :value="overlay" :opacity="0.9">
    <div
      style="height: 100vh; width: 100vw"
      class="d-flex justify-center align-center"
    >
      <CloseButton style="position: absolute; top: 16px; right: 16px" />
      <div @click.stop>
        <v-img
          :src="image"
          :contain="true"
          max-width="90vw"
          max-height="90vh"
        />
      </div>
    </div>
  </v-overlay>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue"
import { LightboxService } from "features/gallery/lightbox/lightbox.service"
import CloseButton from "features/common/ui/CloseButton.vue"

export default defineComponent({
  name: "Lightbox",
  components: { CloseButton },
  props: {
    service: {
      type: Object as PropType<LightboxService>,
      required: true,
    },
  },
  setup(props) {
    const overlay = ref(false)
    const image = ref<string | null>(null)

    const handleOpen = (imageToOpen: string) => {
      image.value = imageToOpen
      overlay.value = true
    }

    props.service.registerCallback(handleOpen)

    const close = () => {
      image.value = null
      overlay.value = false
    }

    return {
      overlay,
      close,
      image,
    }
  },
})
</script>

<style>
@import "photoswipe/dist/photoswipe.css";

.pswp__custom-caption {
  background: rgba(48, 126, 247, 0.75);
  font-size: 16px;
  color: #fff;
  width: fit-content;
  padding: 2px 8px;
  border-radius: 4px;
  position: absolute;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
}
.pswp__custom-caption a {
  color: #fff;
  text-decoration: underline;
}
.hidden-caption-content {
  display: none;
}
</style>
